/**
 * Products Section
 * Grid of products with images, titles, and prices
 */

import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { usePortal } from '../../context/PortalContext';
import { ShoppingCart } from 'lucide-react';

const ProductsSection = ({ title = 'Our Products', limit = 6 }) => {
  const { products, branding } = usePortal();
  const navigate = useNavigate();
  const displayProducts = products.slice(0, limit);

  if (displayProducts.length === 0) {
    return null;
  }

  return (
    <section className="section">
      <div className="container">
        <div className="section-heading">
          <h2>{title}</h2>
          <p>Discover our amazing collection</p>
        </div>

        <div className="grid grid-3">
          {displayProducts.map(product => (
            <div key={product.id} className="card">
              {product.primaryImage && (
                <img 
                  src={product.primaryImage} 
                  alt={product.name} 
                  className="card-image"
                />
              )}
              <div className="card-content">
                <h3 className="card-title">{product.name}</h3>
                <p className="card-description">
                  {product.shortDescription || product.description?.substring(0, 100)}
                </p>
                <div style={styles.footer}>
                  <span className="card-price">${product.price?.toFixed(2)}</span>
                  {/* The site has no cart: every product is ordered through the instant print-order
                      form (sizes, colours, artwork), same as "Order now" on /products. */}
                  <button 
                    type="button"
                    onClick={() => navigate(`/print-order?product=${product.id}`)}
                    title="Order now"
                    aria-label={`Order ${product.name}`}
                    style={{ ...styles.addBtn, background: branding.primaryColor }}
                  >
                    <ShoppingCart size={18} />
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {products.length > limit && (
          <div style={styles.viewAll}>
            <Link 
              to="/products" 
              className="btn btn-secondary"
            >
              View All Products
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};

const styles = {
  footer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '15px',
  },
  addBtn: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    border: 'none',
    color: 'white',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'transform 0.3s',
  },
  viewAll: {
    textAlign: 'center',
    marginTop: '40px',
  },
};

export default ProductsSection;
